module.exports = __webpack_public_path__ + "media/assets/our_value_bg-003d54c18360680e9b045cc843b11206.jpg";